import { Injectable } from '@angular/core';
import { UsuarioResumo } from '../models/auth.model';

export const CHAVE_TOKEN = 'kali_master_token';
export const CHAVE_USUARIO = 'kali_master_usuario';

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  getToken(): string | null {
    return sessionStorage.getItem(CHAVE_TOKEN);
  }

  setToken(token: string): void {
    sessionStorage.setItem(CHAVE_TOKEN, token);
  }

  getUsuario(): UsuarioResumo | null {
    const bruto = sessionStorage.getItem(CHAVE_USUARIO);
    if (!bruto) {
      return null;
    }
    try {
      return JSON.parse(bruto) as UsuarioResumo;
    } catch {
      return null;
    }
  }

  setUsuario(usuario: UsuarioResumo): void {
    sessionStorage.setItem(CHAVE_USUARIO, JSON.stringify(usuario));
  }

  clear(): void {
    sessionStorage.removeItem(CHAVE_TOKEN);
    sessionStorage.removeItem(CHAVE_USUARIO);
  }
}
